import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-4 text-center mt-6">
      <p>© 2025 ग्रामपंचायत लोणारा पोस्ट गुमथी जिल्हा नागपूर  
 | संपर्क: ७८८७४५३९४३</p>
    </footer>
  );
};

export default Footer;
